import type { Ticket, Work } from '@certhon/models';

/**
 * Builds the URL for a ticket based on its project and work association
 * @param ticket - The ticket object containing project_id and werk_id
 * @returns The URL path to the ticket
 */
export function buildTicketUrl(
  ticket: Ticket,
  { work }: { work?: Work } = {},
): string {
  const ticketId = ticket.id;

  if (ticket.project_id) {
    // Fallback for tickets without project association
    return `/projects/${ticket.project_id}/tickets/${ticketId}`;
  }
  if (ticket.werk_id === work?.recnum) {
    return `/projects/${work.project_id}/works/${work.recnum}/tickets/${ticketId}`;
  }
  return `/tickets/${ticketId}`;
}

/**
 * Builds the URL for a ticket using just IDs (for cases where we only have the lookup data)
 * @param ticketId - The ticket ID
 * @param projectId - The project ID (optional)
 * @param werkId - The work ID (optional)
 * @returns The URL path to the ticket
 */
export function buildTicketUrlFromIds(
  ticketId: string,
  projectId?: number | null,
  werkId?: number | null,
): string {
  if (!projectId) {
    return `/tickets/${ticketId}`;
  }

  if (werkId) {
    return `/projects/${projectId}/works/${werkId}/tickets/${ticketId}`;
  } else {
    return `/projects/${projectId}/tickets/${ticketId}`;
  }
}
